export default __webpack_public_path__ + "static/media/aethir.e0728de2.svg";